import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-hook-white",
  "use": "icon-icon-hook-white-usage",
  "viewBox": "0 0 11 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 8\" id=\"icon-icon-hook-white\">\n  <defs>\n    <style>\n      #icon-icon-hook-white .cls-1 {\n        fill: #ffffff;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"m4.79,8c-.25,0-.49-.09-.68-.27L.32,4.23c-.41-.37-.43-1.01-.06-1.41.37-.4,1.01-.43,1.41-.06l3.03,2.8L9.25.34c.36-.42,1-.46,1.41-.1.42.36.46.99.1,1.41l-5.21,6c-.18.21-.43.33-.7.34-.02,0-.04,0-.06,0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-hook-white.svg
// module id = llKx
// module chunks = 87